// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IProcessedReturnedCheckDetailsDto } from './IProcessedReturnedCheckDetailsDto';
import {
    IProcessedReturnedCheckDetailsDtoFromJSON,
    IProcessedReturnedCheckDetailsDtoFromJSONTyped,
    IProcessedReturnedCheckDetailsDtoToJSON,
    IProcessedReturnedCheckDetailsDtoToJSONTyped,
} from './IProcessedReturnedCheckDetailsDto';

/**
 * 
 * @export
 * @interface IProcessedReturnedCheckDto
 */
export interface IProcessedReturnedCheckDto {
    /**
     * 
     * @type {number}
     * @memberof IProcessedReturnedCheckDto
     */
    lockbox_id?: number;
    /**
     * 
     * @type {IProcessedReturnedCheckDetailsDto}
     * @memberof IProcessedReturnedCheckDto
     */
    details?: IProcessedReturnedCheckDetailsDto;
}

/**
 * Check if a given object implements the IProcessedReturnedCheckDto interface.
 */
export function instanceOfIProcessedReturnedCheckDto(value: object): value is IProcessedReturnedCheckDto {
    return true;
}

export function IProcessedReturnedCheckDtoFromJSON(json: any): IProcessedReturnedCheckDto {
    return IProcessedReturnedCheckDtoFromJSONTyped(json, false);
}

export function IProcessedReturnedCheckDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IProcessedReturnedCheckDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lockbox_id': json['lockbox_id'] == null ? undefined : json['lockbox_id'],
        'details': json['details'] == null ? undefined : IProcessedReturnedCheckDetailsDtoFromJSON(json['details']),
    };
}

export function IProcessedReturnedCheckDtoToJSON(json: any): IProcessedReturnedCheckDto {
    return IProcessedReturnedCheckDtoToJSONTyped(json, false);
}

export function IProcessedReturnedCheckDtoToJSONTyped(value?: IProcessedReturnedCheckDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lockbox_id': value['lockbox_id'],
        'details': IProcessedReturnedCheckDetailsDtoToJSON(value['details']),
    };
}

